import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-JRK8628W10';

const getPageTitle = (pathname) => {
  const routes = [
    { match: /^\/$/, title: 'Complimate | Simple & Measurable Compliance Software' },
    { match: /^\/login\/?$/, title: 'Log In | Complimate' },
    { match: /^\/signup\/?$/, title: 'Sign Up | Complimate' },
    { match: /^\/company-signup\/?$/, title: 'Company Sign Up | Complimate' },
    { match: /^\/individual-signup\/?$/, title: 'Individual Sign Up | Complimate' },
    { match: /^\/forgot-password\/?$/, title: 'Forgot Password | Complimate' },
    { match: /^\/forgot-password-otp\/?$/, title: 'Verify OTP | Complimate' },
    { match: /^\/reset-password\/?$/, title: 'Reset Password | Complimate' },
    { match: /^\/contact-us\/?$/, title: 'Contact Us | Complimate' },
    { match: /^\/enquiry\/?$/, title: 'Enquiry | Complimate' },
    { match: /^\/learning-hub\/?$/, title: 'Learning Hub | Complimate' },
    { match: /^\/terms\/?$/, title: 'Terms & Conditions | Complimate' },
    { match: /^\/privacy\/?$/, title: 'Privacy Policy | Complimate' },
    { match: /^\/newSubscription\/?$/, title: 'Choose a Plan | Complimate' },
    { match: /^\/standalone-contact-sales\/?$/, title: 'Contact Sales | Complimate' },
    { match: /^\/dashboard\/?$/, title: 'Dashboard | Complimate' },
    { match: /^\/assistant\/?$/, title: 'Assistant | Complimate' },
    { match: /^\/projects\/?$/, title: 'Projects | Complimate' },
    { match: /^\/documents\/?$/, title: 'Documents | Complimate' },
    { match: /^\/sites\/?$/, title: 'Sites | Complimate' },
    { match: /^\/manage-employee/, title: 'Manage Employees | Complimate' },
    { match: /^\/subscription\/?$/, title: 'Subscription | Complimate' },
    { match: /^\/profile\/?$/, title: 'Profile | Complimate' },
    { match: /^\/settings\/?$/, title: 'Settings | Complimate' },
    { match: /^\/digital-form-management/, title: 'Digital Forms | Complimate' },
    { match: /^\/company-forms/, title: 'Company Forms | Complimate' },
    { match: /^\/asset-record/, title: 'Asset Records | Complimate' },
    { match: /^\/manage-task\/?$/, title: 'Tasks | Complimate' },
    { match: /^\/contact-sales\/?$/, title: 'Contact Sales | Complimate' },
  ];

  const route = routes.find(({ match }) => match.test(pathname));
  return route ? route.title : 'Complimate';
};

function GoogleAnalytics() {
  const location = useLocation();
  const isFirstLoad = useRef(true);

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}`;
    const pageTitle = getPageTitle(location.pathname);

    document.title = pageTitle;

    // First page view is sent by the official gtag snippet in index.html.
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }

    if (typeof window.gtag !== 'function') {
      return;
    }

    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: pagePath,
      page_title: pageTitle,
    });
  }, [location.pathname, location.search]);

  return null;
}

export default GoogleAnalytics;
